"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _styles = require("@material-ui/core/styles");
var _styles2 = require("../utilities/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _button = _interopRequireDefault(require("../button"));
var _excluded = ["classes", "FontAwesomeIconProps"];
var _useClasses = (0, _styles.makeStyles)(function (_ref) {
  var highContrast = _ref.accessibility.highContrast;
  return {
    root: (0, _defineProperty2.default)({}, highContrast.mediaQuery('active'), {
      color: 'WindowText'
    })
  };
});
var SocialIconFactory = function SocialIconFactory(useClasses, icon, title, size) {
  var Icon = function Icon(_ref2) {
    var classes = _ref2.classes,
      FontAwesomeIconProps = _ref2.FontAwesomeIconProps,
      rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
    var _classes = useClasses();
    var _commonClasses = _useClasses();
    return /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({
      title: title,
      "aria-label": title
    }, rest, {
      classes: (0, _styles2.mergeClasses)({
        root: (0, _clsx.default)(_classes.root, _commonClasses.root),
        focusVisible: _classes.focus
      }, classes)
    }), /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, (0, _extends2.default)({
      icon: icon,
      size: size,
      fixedWidth: true
    }, FontAwesomeIconProps)));
  };
  Icon.propTypes = {
    classes: _propTypes.default.object,
    FontAwesomeIconProps: _propTypes.default.object,
    size: _propTypes.default.string
  };
  Icon.defaultProps = {
    classes: null,
    FontAwesomeIconProps: {},
    size: '2x'
  };
  return Icon;
};
var _default = SocialIconFactory;
exports.default = _default;